import React from "react";
//#region types
import { LocalizationHelperInstance } from "utils/helpers";
import { IconDefinitionConstants } from "utils/constants";
import { DialogEnums } from "models/enums";
import { DialogProps } from "models/propTypes/dialogPropTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import SalaryDraftRejectFormContainer from "./rejectFormContainer";
//#endregion

function useSalaryDraftRejectDialog(
  onRejectSuccess?: (value?: any) => void,
  onError?: (value?: any) => void,
  disableSuccessMessages?: boolean
) {
  const getRejectDialog = (salaryDraftId: number): DialogProps => {
    return {
      isOpen: false,
      title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Reject),
      titleIcon: IconDefinitionConstants.WCalendar,
      actions: [
        {
          text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Send),
          successMessage: TranslationKeys.Salary.SalaryDraftRejectSuccessMessage,
        },
      ],
      dialogType: DialogEnums.DialogType.Content,
      children: <SalaryDraftRejectFormContainer salaryDraftId={salaryDraftId}></SalaryDraftRejectFormContainer>,
      maxWidth: "sm",
      onSubmit: onRejectSuccess,
      onError: onError,
      disbleSuccessMessages: disableSuccessMessages,
    };
  };

  return getRejectDialog;
}

export default useSalaryDraftRejectDialog;
